/**
 * Format a chat message timestamp as a locale time string, degrading to an empty
 * string for a missing or unparseable value — never the literal "Invalid Date".
 *
 * The real chat path always stamps an ISO `timestamp` (session_manager / WS append),
 * so this guard rarely fires in production — but it makes a bad/absent value
 * structurally impossible to surface in the UI (pre-stamping messages, malformed WS
 * frames, e2e fixtures). The data-origin layer is the seed-fixture timestamp fix;
 * this is the consumption-layer net. (ChatDAGRAGDAG C2.1 — "Invalid Date" defense.)
 */
export function formatMessageTime(timestamp?: string | null): string {
  if (!timestamp) return '';
  const d = new Date(timestamp);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleTimeString();
}
